import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import FormDataImgUploader from 'modules/Teasers/EditTeaser/components/Forms/components/EditForm/FormDataImgUploader/FormDataImgUploader';
import { EditTeaserContext, IEditTeaserContext } from 'modules/Teasers/EditTeaser/editTeaserState/editTeaserContext';
import FormDataTeaserUploader from './FormDataTeaserUploader/FormDataTeaserUploader';
import React, { useContext } from 'react';
import classNames from 'classnames';
import InputFields from './InputFields/InputFields';
import style from './EditForm.module.scss';

interface IEditForm {
	isVisible: boolean;
}

const EditForm: React.FC<IEditForm> = ({ isVisible }) => {
	const { selectedContentType } = useContext<IEditTeaserContext>(EditTeaserContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const renderUploader = () => {
		const photoContentType =
			selectedContentType === 'AdvertisingImage' ||
			selectedContentType === 'AssistantImage' ||
			selectedContentType === 'GameLaunchImage';
		const videoContentType =
			selectedContentType === 'AdvertisingVideo' ||
			selectedContentType === 'AssistantVideo' ||
			selectedContentType === 'GameLaunchVideo';

		if (photoContentType) {
			return <FormDataImgUploader />;
		}
		if (videoContentType) {
			return <FormDataTeaserUploader />;
		}
		return <FormDataTeaserUploader />;
	};

	return (
		<div className={containerClasses} data-test="EditForm">
			<WithAdditionalValidationState>
				{renderUploader()}
				<InputFields />
			</WithAdditionalValidationState>
		</div>
	);
};

export default EditForm;
